import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { emailSuggestion } from '../../../utils/email/email-validator';

/**
 * Aviso no bloqueante «¿Quisiste decir X?». Al pulsarlo sustituye el valor del control.
 * Uso: <app-email-suggestion [control]="miControl"></app-email-suggestion>
 */
@Component({
  selector: 'app-email-suggestion',
  template: `
    <div class="email-suggestion" *ngIf="suggestion as s" role="status">
      {{ 'validarions.email_did_you_mean_prefix' | translate }}
      <button type="button" class="email-suggestion__btn" (click)="apply(s)">{{ s }}</button>?
    </div>
  `,
  styles: [
    `
      .email-suggestion {
        font-size: 0.8rem;
        margin: -1rem 0 1rem 0.75rem;
      }
      .email-suggestion__btn {
        background: none;
        border: 0;
        padding: 0;
        font: inherit;
        font-weight: 500;
        color: inherit;
        text-decoration: underline;
        cursor: pointer;
      }
    `,
  ],
})
export class EmailSuggestionComponent {
  @Input() control: AbstractControl;

  /** Se muestra al salir del campo, para no molestar mientras se escribe. */
  get suggestion(): string | null {
    if (!this.control || !this.control.touched) {
      return null;
    }
    return emailSuggestion(this.control.value);
  }

  apply(value: string) {
    this.control.setValue(value);
    this.control.markAsDirty();
    this.control.markAsTouched();
  }
}
